import React, { useEffect, useState } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import Icon from '@mdi/react';
import { mdiPlayCircleOutline } from '@mdi/js';

import SwiperCore, {
  Pagination,
} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper-bundle.css';

import Container from '@components/Container';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  sliderContainer: {
    width: '100%',
    margin: [20, 0],
    overflowX: 'hidden',
    '& .swiper-wrapper': {
      height: rem(400),
      boxShadow: '0px 2px 6px 0px rgba(229,229,229,1)',
    },
    '& .swiper-slide': {
      overflow: 'hidden',
      height: rem(400),
      borderRadius: 8,
      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    '& .swiper-pagination': {
      bottom: 0,
    },
  },
  sVideo: {
    width: '100%',
    height: rem(370),
    margin: '0 auto',
    objectFit: 'cover',
  },
  pretend: {
    position: 'relative',
    height: rem(400),
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 0, 0, .1)',
    '& > img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      opacity: '0.75',
    },
  },
  play: {
    position: 'absolute',
    color: 'rgba(0, 0, 0, .9)',
  },
}), {
  name: 'CarouselShow'
})

SwiperCore.use([Pagination]);

const CarouselShow = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { data } = props;

  const [isPlay, setIsPlay] = useState(false);

  const skuData = R.pathOr({}, ['jsonData', 'sku'])(data);
  // 封面
  const cover = R.pathOr({}, ['base', 'mainimage'])(skuData);

  const mainvideo = R.pathOr({}, ['custom', 'mainvideo'])(skuData);
  const carouselimagelist = R.pathOr([], ['custom', 'carouselimagelist'])(skuData);

  const createCover = () => {
    if (Object.keys(cover).length === 0) return null;
    return (
      <SwiperSlide>
        <img
          src={R.pathOr('', ['filelocation'])(cover)}
          alt={R.pathOr('', ['filename'])(cover)}
          width='100%'
        />
      </SwiperSlide>
    )
  }

  useEffect(() => {
    // 监控停止事件，停止将恢复原状
    const main = global.document.getElementById('main');
    if (main) {
      main.addEventListener('pause', () => {
        setIsPlay(false);
      });
    }
  }, [isPlay]);

  const createPretendPlay = () => {
    if (Object.keys(mainvideo).length === 0) return null;
    return (
      <SwiperSlide>
        <Container
          flex
          direction='column'
          alignItems='center'
          justify='center'
          className={classes.pretend}
          onClick={() => setIsPlay(true)}
        >
          <img
            src={R.pathOr('', ['filelocation'])(cover)}
            alt={R.pathOr('', ['filename'])(cover)}
            width='100%'
          />
          <Icon
            size={0.8}
            path={mdiPlayCircleOutline}
            className={classNames(classes.play)}
          />
        </Container>
      </SwiperSlide>
    )
  }

  const createMainVideo = () => {
    if (Object.keys(mainvideo).length === 0) return null;
    const img = R.pathOr({}, ['base', 'mainimage', 'filelocation'])(skuData);
    return (
      <SwiperSlide>
        <video
          id="main"
          muted
          playsInline
          preload="true"
          autoPlay={true}
          poster={img}
          className={classes.sVideo}
          controls='controls'
          src={R.pathOr('', ['filelocation'])(mainvideo)}
        >
          <source src={R.pathOr('', ['filelocation'])(mainvideo)}type="video/mp4" />
        </video>
      </SwiperSlide>
    )
  }

  const createOtherImages = () => {
    if (!carouselimagelist.length) return null;
    return (carouselimagelist && carouselimagelist.length > 0) && (
      carouselimagelist.map((item, index) => (
        <SwiperSlide key={String(index)}>
          <img
            src={R.pathOr('', ['filelocation'])(item)}
            alt={R.pathOr('', ['filename'])(item)}
            width='100%'
          />
        </SwiperSlide>
      ))
    )
  }

  return (
    <Container className={classNames(classes.root)} id='product'>
      <h2 className={classes.title} value='product' style={{ display: 'none' }}>产品</h2>
      {
        data ? (
          <Swiper
            loop
            spaceBetween={50}
            pagination={{ clickable: true }}
            className={classNames(classes.sliderContainer)}
          >
            {createCover()}

            {(mainvideo && isPlay) ? createMainVideo() : createPretendPlay()}

            {
              carouselimagelist && createOtherImages()
            }
          </Swiper>
        ) : null
      }
    </Container>
  )
};

CarouselShow.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CarouselShow;
